import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { kratos } from "../sdk/kratos"

export const Logout = () => {
  const navigate = useNavigate()

  useEffect(() => {
    async function runLogout() {
      try {
        const { data } = await kratos.createBrowserLogoutFlow()
        if (data.logout_url) {
          window.location.href = data.logout_url
          return
        }
      } catch (err) {
        console.error("Failed to create logout flow", err)
      }
      navigate("/login")
    }

    runLogout()
  }, [navigate])

  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-gray-700">Signing you out…</p>
    </div>
  )
}
